import { xEnsureFloat64 } from 'ml-spectra-processing';
import { fftIndirectDimension, } from '../../../xyz/util/fft2d/fftIndirectDimension';
import { getMinMaxXY } from '../../../xyz/util/getMinMaxXY';
export const id = 'fftDimension2';
export const name = 'FFT Dimension 2';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: true,
};
export function apply(datum2D, options) {
    if (!isApplicable(datum2D)) {
        throw new Error('fft dimension 2 not applicable on this data');
    }
    const { data, info } = datum2D;
    const fnMode = info.fnMode[1];
    const orderedData = {
        re: data.re.z,
        im: data.im.z,
    };
    const { zeroFilling = {} } = options;
    const nbRows = orderedData.re.length;
    const { factor = 2 } = zeroFilling;
    const nbPoints = zeroFilling?.nbPoints || 2 ** Math.round(Math.log2(nbRows * factor));
    const transformed = fftIndirectDimension({
        re: orderedData.re,
        im: orderedData.im,
    }, {
        fnMode,
        ...options,
        zeroFilling: { nbPoints },
    });
    datum2D.data = {
        ...getQuadrants(transformed, info),
    };
    const { isFid, isComplex, ...resInfo } = info;
    datum2D.info = {
        ...resInfo,
        isFt: true,
    };
}
function getQuadrants(transformed, info) {
    const quadrants = {};
    const { fnMode } = info;
    const minMaxXY = getMinMaxXY(info);
    const buildQuandrants = (keys) => {
        for (const key of keys) {
            quadrants[key] = {
                z: transformed[key].to2DArray().map(xEnsureFloat64),
                maxZ: transformed[key].max(),
                minZ: transformed[key].min(),
                ...minMaxXY,
            };
        }
        return quadrants;
    };
    if (fnMode[1] === 'QF') {
        return buildQuandrants(['rr', 'ir']);
    }
    return buildQuandrants(['rr', 'ir', 'ri', 'ii']);
}
export function isApplicable(datum2D) {
    if (datum2D.info.isComplex && datum2D.info.isFid)
        return true;
    return false;
}
export function reduce() {
    return {
        once: true,
        reduce: undefined,
    };
}
//# sourceMappingURL=fftDimension2.js.map